import { Button } from '@bambi/component-library/src/components/Button';
import { FormProvider, useForm } from 'react-hook-form';

import { PassengerAddressForm } from './PassengerAddressForm';
import { useAppDispatch } from 'src/app/store/hooks';
import type { PassengerAddressRead } from 'src/common/external/bambi-api/bambiApi';
import { useLocationsPassengerAddressesPartialUpdateMutation } from 'src/common/external/bambi-api/bambiApi';
import { Modal } from 'src/common/primitives/Modal/Modal';
import { show } from 'src/common/primitives/Toast/toast.slice';
import formatServerError from 'src/common/util/serverErrorFormatter';

export function PassengerAddressFormModal({
  open,
  setOpen,
  onClose,
  passengerAddress,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose: () => void;
  passengerAddress: PassengerAddressRead;
}) {
  const dispatch = useAppDispatch();
  const methods = useForm<PassengerAddressRead>({
    defaultValues: {
      ...passengerAddress,
    },
  });
  const { handleSubmit } = methods;

  const [updateAddress] = useLocationsPassengerAddressesPartialUpdateMutation();

  const handleUpdate = handleSubmit(async (data) => {
    try {
      await updateAddress({
        id: passengerAddress.id,
        patchedPassengerAddressRequest: data,
      }).unwrap();
      dispatch(
        show({
          title: 'Address updated successfully',
          description: 'The address has been updated successfully.',
          type: 'success',
        })
      );
      onClose();
    } catch (e) {
      dispatch(
        show({
          title: 'Failed to update address',
          description: formatServerError(e),
          type: 'error',
        })
      );
    }
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      onClose={onClose}
      contentClassnames="w-[400px]"
    >
      <div className="flex flex-col gap-4">
        <h4 className="text-lg font-medium text-gray-900">Edit Address</h4>
        <FormProvider {...methods}>
          <PassengerAddressForm />
        </FormProvider>
      </div>
      <div className="mt-4 flex flex-row justify-between gap-2">
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleUpdate}>
          Save
        </Button>
      </div>
    </Modal>
  );
}
